module.exports = __webpack_public_path__ + "static/media/about.b8f4ed60.jpg";